import { Layout } from "antd";
import React, { Suspense, memo } from "react";

import Compare from "./Compare";
import SimpleSpinner from "./SimpleSpinner";

const App = (): JSX.Element => (
  <Suspense fallback={<SimpleSpinner />}>
    <Layout>
      <div className="app-container">
        <Compare />
      </div>
    </Layout>
  </Suspense>
);

export default memo(App);
